/**
 * 구분선을 표시하는 컴포넌트
 */

import { StyledLine } from './Line.styles';

const Line = () => {
  return <StyledLine />
}

export default Line 